import React from 'react';

const SubscriptionContext = React.createContext({
  socket: null,
  connected: false
});

export default SubscriptionContext;
